export default {
  noutati_label: 'News',
  documente_discutie_label: 'Discussion documents',
  buletine_informative_label: 'Informative bulletins',
  energie_electrica_label: 'Electrical energy',
  gaze_naturale_label: 'Natural gases',
  copyright: 'All rights reserved.',
  termeni_si_conditii: 'Terms and conditions',
  pagina_termeni_si_conditii: 'terms-and-conditions'
}
